import {
	clearButton,
	SELECTED_STORE,
	SELECTED_ITEM,
	SELECTED_CATEGORIES,
	SELECTED_DEPARTMENTS,
	SELECTED_BRANDS,
	SELECTED_UPC,
	SELECTED_SUBCATEGORY,
	SUBCATEGORY,
} from '../../../constants/constant';

const content = {
	Store: {
		add: {
			key: 'storeId',
			item: 'Store',
			title: 'Add Stores',
			inputPlaceholder: 'Store #',
			pasteButton: 'Paste Store #',
			checkBoxAggregated: 'Set alert for Aggregated stores',
			checkBoxIndividual: 'Set alert for individual store',
			selectedItems: SELECTED_STORE,
		},
		addBulk: {
			key: 'storeId',
			item: 'Store',
			title: 'Add Bulk Store #',
			clearButton,
			inputPlaceholder: 'Paste store # list',
			selectedItems: SELECTED_STORE,
			selectValid: 'Select all valid stores',
		},
	},
	Item: {
		add: {
			key: 'itemId',
			item: 'Item',
			title: 'Add Items',
			inputPlaceholder: 'Item #',
			pasteButton: 'Paste Item #',
			checkBoxAggregated: 'Set alert for Aggregated items',
			checkBoxIndividual: 'Set alert for individual item',
			selectedItems: SELECTED_ITEM,
		},
		addBulk: {
			key: 'itemId',
			item: 'Item',
			title: 'Add Bulk Item #',
			clearButton,
			inputPlaceholder: 'Paste item # list',
			selectedItems: SELECTED_ITEM,
			selectValid: 'Select all valid items',
		},
	},
	Category: {
		add: {
			key: 'catId',
			item: 'Category',
			title: 'Add Categories',
			inputPlaceholder: 'Category #',
			pasteButton: 'Paste Category #',
			checkBoxAggregated: 'Set alert for Aggregated categories',
			checkBoxIndividual: 'Set alert for individual category',
			selectedItems: SELECTED_CATEGORIES,
		},
		addBulk: {
			key: 'catId',
			item: 'Category',
			title: 'Add Bulk Category #',
			clearButton,
			inputPlaceholder: 'Paste category # list',
			selectedItems: SELECTED_CATEGORIES,
			selectValid: 'Select all valid categories',
		},
	},
	Department: {
		add: {
			key: 'deptId',
			item: 'Department',
			title: 'Add Departments',
			inputPlaceholder: 'Department #',
			pasteButton: 'Paste Department #',
			checkBoxAggregated: 'Set alert for Aggregated departments',
			checkBoxIndividual: 'Set alert for individual department',
			selectedItems: SELECTED_DEPARTMENTS,
		},
		addBulk: {
			key: 'deptId',
			item: 'Department',
			title: 'Add Bulk Department #',
			clearButton,
			inputPlaceholder: 'Paste department # list',
			selectedItems: SELECTED_DEPARTMENTS,
			selectValid: 'Select all valid departments',
		},
	},
	Brand: {
		add: {
			key: 'brandName',
			item: 'Brand',
			title: 'Add Brands',
			inputPlaceholder: 'Brand Name',
			pasteButton: 'Paste Brand #',
			checkBoxAggregated: 'Set alert for Aggregated brands',
			checkBoxIndividual: 'Set alert for individual brand',
			selectedItems: SELECTED_BRANDS,
		},
		addBulk: {
			key: 'brandName',
			item: 'Brand',
			title: 'Add Bulk Brand Name',
			clearButton,
			inputPlaceholder: 'Paste brand # list',
			selectedItems: SELECTED_BRANDS,
			selectValid: 'Select all valid Brands',
		},
	},
	UPC: {
		add: {
			key: 'wmUpcNbr',
			item: 'UPC',
			title: 'Add UPC',
			inputPlaceholder: 'UPC #',
			pasteButton: 'Paste UPC #',
			checkBoxAggregated: 'Set alert for Aggregated UPC',
			checkBoxIndividual: 'Set alert for individual UPC',
			selectedItems: SELECTED_UPC,
		},
		addBulk: {
			key: 'wmUpcNbr',
			item: 'UPC',
			title: 'Add Bulk UPC #',
			clearButton,
			inputPlaceholder: 'Paste UPC # list',
			selectedItems: SELECTED_UPC,
			selectValid: 'Select all valid UPC ids',
		},
	},
	Subcategory: {
		add: {
			key: 'subCatId',
			item: SUBCATEGORY,
			title: 'Add Sub-categories',
			inputPlaceholder: 'Sub-category #',
			pasteButton: 'Paste Sub-category #',
			checkBoxAggregated: 'Set alert for Aggregated Sub-categories',
			checkBoxIndividual: 'Set alert for individual Sub-category',
			selectedItems: SELECTED_SUBCATEGORY,
		},
		addBulk: {
			key: 'subCatId',
			item: SUBCATEGORY,
			title: 'Add Bulk Sub-category #',
			clearButton,
			inputPlaceholder: 'Paste Sub-category # list',
			selectedItems: SELECTED_SUBCATEGORY,
			selectValid: 'Select all valid sub-categories',
		},
	},
	store: {
		add: {
			key: 'storeId',
			item: 'Store',
			title: 'Add Stores',
			inputPlaceholder: 'Store #',
			pasteButton: 'Paste Store #',
			checkBoxAggregated: 'Set alert for Aggregated stores',
			checkBoxIndividual: 'Set alert for individual store',
			selectedItems: SELECTED_STORE,
		},
		addBulk: {
			key: 'storeId',
			item: 'Store',
			title: 'Add Bulk Store #',
			clearButton,
			inputPlaceholder: 'Paste store # list',
			selectedItems: SELECTED_STORE,
			selectValid: 'Select all valid stores',
		},
	},
	item: {
		add: {
			key: 'itemId',
			item: 'Item',
			title: 'Add Items',
			inputPlaceholder: 'Item #',
			pasteButton: 'Paste Item #',
			checkBoxAggregated: 'Set alert for Aggregated items',
			checkBoxIndividual: 'Set alert for individual item',
			selectedItems: SELECTED_ITEM,
		},
		addBulk: {
			key: 'itemId',
			item: 'Item',
			title: 'Add Bulk Item #',
			clearButton,
			inputPlaceholder: 'Paste item # list',
			selectedItems: SELECTED_ITEM,
			selectValid: 'Select all valid items',
		},
	},
	category: {
		add: {
			key: 'catId',
			item: 'Category',
			title: 'Add Categories',
			inputPlaceholder: 'Category #',
			pasteButton: 'Paste Category #',
			checkBoxAggregated: 'Set alert for Aggregated categories',
			checkBoxIndividual: 'Set alert for individual category',
			selectedItems: SELECTED_CATEGORIES,
		},
		addBulk: {
			key: 'catId',
			item: 'Category',
			title: 'Add Bulk Category #',
			clearButton,
			inputPlaceholder: 'Paste category # list',
			selectedItems: SELECTED_CATEGORIES,
			selectValid: 'Select all valid categories',
		},
	},
	department: {
		add: {
			key: 'deptId',
			item: 'Department',
			title: 'Add Departments',
			inputPlaceholder: 'Department #',
			pasteButton: 'Paste Department #',
			checkBoxAggregated: 'Set alert for Aggregated departments',
			checkBoxIndividual: 'Set alert for individual department',
			selectedItems: SELECTED_DEPARTMENTS,
		},
		addBulk: {
			key: 'deptId',
			item: 'Department',
			title: 'Add Bulk Department #',
			clearButton,
			inputPlaceholder: 'Paste department # list',
			selectedItems: SELECTED_DEPARTMENTS,
			selectValid: 'Select all valid departments',
		},
	},
	brand: {
		add: {
			key: 'brandName',
			item: 'Brand',
			title: 'Add Brands',
			inputPlaceholder: 'Brand #',
			pasteButton: 'Paste Brand #',
			checkBoxAggregated: 'Set alert for Aggregated brands',
			checkBoxIndividual: 'Set alert for individual brand',
			selectedItems: SELECTED_BRANDS,
		},
		addBulk: {
			key: 'brandName',
			item: 'Brand',
			title: 'Add Bulk Brand #',
			clearButton,
			inputPlaceholder: 'Paste brand # list',
			selectedItems: SELECTED_BRANDS,
			selectValid: 'Select all valid brands',
		},
	},
	upc: {
		add: {
			key: 'wmUpcNbr',
			item: 'UPC',
			title: 'Add UPC',
			inputPlaceholder: 'UPC #',
			pasteButton: 'Paste UPC #',
			checkBoxAggregated: 'Set alert for Aggregated UPC',
			checkBoxIndividual: 'Set alert for individual UPC',
			selectedItems: SELECTED_UPC,
		},
		addBulk: {
			key: 'wmUpcNbr',
			item: 'UPC',
			title: 'Add Bulk UPC #',
			clearButton,
			inputPlaceholder: 'Paste UPC # list',
			selectedItems: SELECTED_UPC,
			selectValid: 'Select all valid UPC ids',
		},
	},
	subcategory: {
		add: {
			key: 'subCatId',
			item: SUBCATEGORY,
			title: 'Add Sub-categories',
			inputPlaceholder: 'Sub-category #',
			pasteButton: 'Paste Sub-category #',
			checkBoxAggregated: 'Set alert for Aggregated Sub-categories',
			checkBoxIndividual: 'Set alert for individual Sub-category',
			selectedItems: SELECTED_SUBCATEGORY,
		},
		addBulk: {
			key: 'subCatId',
			item: SUBCATEGORY,
			title: 'Add Bulk Sub-category #',
			clearButton,
			inputPlaceholder: 'Paste Sub-category # list',
			selectedItems: SELECTED_SUBCATEGORY,
			selectValid: 'Select all valid sub-categories',
		},
	},
};

export default content;
